import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { DevelopmentService, UserService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';
import { ToastrService } from 'ngx-toastr';

@Component({
   selector: 'mnf-modal-pay-performance',
   templateUrl: './modal-pay-performance.component.html',
   styleUrls: ['./modal-pay-performance.component.scss']
})
export class ModalPayPerformanceComponent implements OnInit {

   /** Información del proyecto */
   project: any;

   /** Formularios a cargar */
   formPay: FormGroup;
   formAccept: FormGroup;

   /** Mostrar formulario de ingresos de hotel */
   showCalculate: boolean = false;

   /** Información de los calculos */
   infoCalculate: any;
   
   /** Obtener mes anterior a pagar */
   lastMonth: any;

   /** Fecha de corte */
   dateCut: Date = new Date();

   /** Modal para indicar si quiere aceptar recursos */
   modalPay: MatDialogRef<any>;

   actualStatus: string;

   /** Wallet detalles */
   walletInfo: any;

   constructor(
      private fb: FormBuilder,
      private dialogRef: MatDialogRef<ModalPayPerformanceComponent>,
      private modalServ: ModalService,
      private toast: ToastrService,
      private devServ: DevelopmentService,
      private userServ: UserService
   ) { }

   ngOnInit(): void {

      /** Función para obtener el monto total de participaciones a pagar */
      this.devServ.getRegalia(this.project.pid).subscribe(res => {
         this.infoCalculate = res?.r;
         this.actualStatus = res?.r?.status;

         if(this.actualStatus == 'paid') {
            this.showCalculate = false;
         } else if(this.actualStatus == 'pending') {
            this.showCalculate = true;
         } else if (this.actualStatus == null || this.actualStatus == undefined) {
            this.showCalculate = false;
         }
      });

      this.userServ.getUserInf().subscribe(res => {
         this.walletInfo = res.wallet;
      })

      // Obtener el mes anterior de la fecha de distribución
      let dateFormat = new Date(this.project?.nextDist);
      this.lastMonth = dateFormat.setMonth(dateFormat.getMonth() - 1);

      // Fecha de corte
      this.dateCut.setDate(1);

      // Inicializar formulario para obtener el total ganado
      this.formPay = this.fb.group({
         totalWin: new FormControl('', ([Validators.required])),
      });

      // Inicializar formulario para aceptar pago
      this.formAccept = this.fb.group({
         acceptPay: new FormControl('', ([Validators.required])),
      });

      // Obtener el tiempo real valor de aceptar pago
      this.formAccept.get('acceptPay').valueChanges.subscribe(r => { })

   }

   /** Mostrar modal de confirmación para aceptar el calculo de regalias */
   calculateToPay() {
      // Obtener el valor del formulario
      const valueForm = { ...this.formPay.value };

      // Mostrar modal de confirmación
      const m = this.modalPay = this.modalServ.modalCustom({
         img: 'https://static.monific.com/assets/assets-app/img/icon/img/no_balance.svg',
         header: 'Aviso',
         title: '¡Importante!',
         message: '¿Estas seguro que el monto ingresado es el correcto?',
         buttonText: 'Continuar',
         cancelText: 'Salir'
      });

      // Obtener el valor del formulario
      m.afterClosed().subscribe(res => {
         if(res) {
            // Mandar el monto total de ganancias para calcular el total a pagar
            this.devServ.saveInfoRegalia(this.project.pid, valueForm.totalWin).subscribe(res => {
               this.infoCalculate = res?.r;
               this.showCalculate = true;
            });
         } else {
            this.dialogRef.close();
            this.toast.warning('Operación cancelada');
         }
      })
   }

   next() {
      this.devServ.payRegalias(this.project.pid).subscribe(res => {
         if(res.response.status == 'OK') {
            this.toast.success('Regalias pagadas exitosamente');
            setTimeout(() => {
               window.location.reload();
            }, 3000)
         } else {
            this.toast.warning('Ocurrio un error al pagar regalias');
         }
      })
   }

   /** Función para cerrar el modal actual */
   close() {
      this.dialogRef.close();
   }


}
